/** The per-company rollout payload shared by the `new-admission-form`, `new-invitation-form` and `new-addon-form` flags. */
export interface CompanyRolloutPayload {
  allowedCompanyIds: number[];
  allCompanies?: boolean;
}

/**
 * Defensive read of a per-company "new form" flag + payload (`new-admission-form`,
 * `new-invitation-form`, `new-addon-form`). Returns false if the payload is malformed (missing `allowedCompanyIds`,
 * wrong type), so a bad edit in the PostHog UI can't break the offers tab.
 *
 * An explicit `allCompanies: true` opts every company in without enumerating IDs — a single
 * deliberate PostHog edit for the eventual full rollout (B2B-1703). The boolean flag is still
 * required, and the sentinel must be the literal `true`, so the gate stays fail-closed for empty or
 * malformed payloads.
 */
export const shouldShowNewForm = (
  isFlagEnabled: boolean,
  payload: CompanyRolloutPayload | undefined,
  companyLegacyId: string
): boolean => {
  if (!isFlagEnabled) {
    return false;
  }

  if (payload?.allCompanies === true) {
    return true;
  }

  const allowedCompanyIds = payload?.allowedCompanyIds;
  return Array.isArray(allowedCompanyIds) && allowedCompanyIds.includes(Number(companyLegacyId));
};
